export default __webpack_public_path__ + "static/media/meeting.21275dad.png";